export default __webpack_public_path__ + "static/media/amei.9a990b68.gif";